import request from '@/utils/request'

//使用
export function getInfo(params) {
  return request({
    url: '/list.api',
    method: 'post',
    params
  });
}

//使用
export function getData(URLS, params) {
  return request({
    url: URLS,
    method: 'post',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/api.js